export default __webpack_public_path__ + "static/media/doc.d3c182db.png";